import { createContext, useContext } from 'react'
import type { RefObject } from 'react'

const KitlookPurchaseActionsContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null)

export const KitlookPurchaseActionsProvider =
  KitlookPurchaseActionsContext.Provider

export function useKitlookPurchaseActionsRef() {
  return useContext(KitlookPurchaseActionsContext)
}
